import { memo, useContext } from "react";
import { Routes, Route } from "react-router-dom";
import BasicAppShell from "../Components/Layout/BasicAppShell";
import ManageVerticals from "../Components/AdminMasters/ManageVerticals/ManageVerticals.component";
import AddVerticals from "../Components/AdminMasters/ManageVerticals/AddVerticals/AddVerticals.component";
import Draft from "../Components/ComputeLca/DraftList.component.tsx/Draft.component";
import NewLca from "../Components/ComputeLca/NewLCA/NewLca.component";
import AddCategoryComponent from "../Components/AdminMasters/ManageProductsCategory/AddCategory/AddCategory.component";
import ManageProductsCategoryComponent from "../Components/AdminMasters/ManageProductsCategory/ManageProductsCategory.component";
import ManageRawMaterialComponent from "../Components/AdminMasters/ManageRawMaterial/ManageRawMaterial.component";
import AddrawmaterialComponent from "../Components/AdminMasters/ManageRawMaterial/AddRawMaterial/Addrawmaterial.component";
import ManageProductComponent from "../Components/AdminMasters/ManageProduct/ManageProduct.component";
import AddProductsComponent from "../Components/AdminMasters/ManageProduct/AddProducts/AddProducts.component";
import Login from "../Components/LandingPage/Login";
import MaterialSubTypeComponent from "../Components/AdminMasters/ManageMaterialSubType/MaterialSubType.component";
import AddMaterialSubTypeComponent from "../Components/AdminMasters/ManageMaterialSubType/AddMaterialSubType/AddMaterialSubType.component";
import ManageTransportComponent from "../Components/AdminMasters/ManageTransport/ManageTransport.component";
import AddTransportComponent from "../Components/AdminMasters/ManageTransport/AddTransport/AddTransport.component";
import ManagepalletsComponent from "../Components/AdminMasters/ManagePallets/Managepallets.component";
import AddPalletsComponent from "../Components/AdminMasters/ManagePallets/AddPallets/AddPallets.component";
import ManagePackageBoxComponent from "../Components/AdminMasters/ManagePackageBox/ManagePackageBox.component";
import AddPackageBoxComponent from "../Components/AdminMasters/ManagePackageBox/AddPackageBox/AddPackageBox.component";
import ManageCustomerComponent from "../Components/AdminMasters/ManageCustomer/ManageCustomer.component";
import AddCustomerComponent from "../Components/AdminMasters/ManageCustomer/AddCustomer/AddCustomer.component";
import ManageFactoryComponent from "../Components/AdminMasters/ManageFactory/ManageFactory.component";
import AddFactoryComponent from "../Components/AdminMasters/ManageFactory/AddFactory/AddFactory.component";
import ManageDbVersionComponent from "../Components/AdminMasters/ManageDbVersion/ManageDbVersion.component";
import AddDbVersionComponent from "../Components/AdminMasters/ManageDbVersion/AddDbVersion/AddDbVersion.component";
import { authContext } from "../context/AuthProvider.component";
import { NotFoundImage } from "../NotFoundComponent/NotFoundPage.component";
import ManageProcessComponent from "../Components/AdminMasters/ManageProcess/ManageProcess.component";
import AddProcessComponent from "../Components/AdminMasters/ManageProcess/AddProcess/AddProcess.component";
import Dashboard from "../Components/Dashboard/Dashboard.component";
import LcaReportPageComponent from "../Components/LCAReportPage/LcaReportPage.component";
import ManageDisposalComponent from "../Components/AdminMasters/ManageDisposal/ManageDisposal.component";
import AddDisposalComponent from "../Components/AdminMasters/ManageDisposal/AddDisposal/AddDisposal.component";
import ProtectedRoute from "./ProtectedRoute";

interface RouteConfig {
  path: string;
  element: JSX.Element;
  isProtected?: boolean;
  requiredRole?: 'LCA-Admin' | 'user';
  showUnauthorized?: boolean;
}

// Route configuration array
const routeConfig: RouteConfig[] = [
  // Public/User routes (accessible to all authenticated users)
  {
    path: '/dashboard',
    element: <Dashboard />,
    isProtected: false
  },
  {
    path: '/newlca',
    element: <NewLca />,
    isProtected: false
  },
  {
    path: '/newlca/sub-category',
    element: <NewLca />,
    isProtected: false
  },
  {
    path: '/draft',
    element: <Draft />,
    isProtected: false
  },
  {
    path: '/lca-report',
    element: <LcaReportPageComponent />,
    isProtected: false
  },
  {
    path: '/manage-products',
    element: <ManageProductComponent />,
    isProtected: true,
    requiredRole: 'LCA-Admin'
  },
  {
    path: '/manage-products/addproduct/:id?',
    element: <AddProductsComponent />,
    isProtected: true,
    requiredRole: 'LCA-Admin'
  },
  {
    path: '/manage-products-category',
    element: <ManageProductsCategoryComponent />,
    isProtected: true,
    requiredRole: 'LCA-Admin'
  },
  {
    path: '/manage-products-category/addcategory/:id?',
    element: <AddCategoryComponent />,
    isProtected: true,
    requiredRole: 'LCA-Admin'
  },
  {
    path: '/manage-raw-material',
    element: <ManageRawMaterialComponent />,
    isProtected: true,
    requiredRole: 'LCA-Admin'
  },
  {
    path: '/manage-raw-material/addrawmaterial/:id?',
    element: <AddrawmaterialComponent />,
    isProtected: true,
    requiredRole: 'LCA-Admin'
  },
  {
    path: '/manage-verticals',
    element: <ManageVerticals />,
    isProtected: true,
    requiredRole: 'LCA-Admin'
  },
  {
    path: '/manage-verticals/addverticals/:id?',
    element: <AddVerticals />,
    isProtected: true,
    requiredRole: 'LCA-Admin'
  },
  {
    path: '/material-subtype',
    element: <MaterialSubTypeComponent />,
    isProtected: true,
    requiredRole: 'LCA-Admin'
  },
  {
    path: '/material-subtype/addmaterial-subtype/:id?',
    element: <AddMaterialSubTypeComponent />,
    isProtected: true,
    requiredRole: 'LCA-Admin'
  },
  {
    path: '/transport',
    element: <ManageTransportComponent />,
    isProtected: true,
    requiredRole: 'LCA-Admin'
  },
  {
    path: '/transport/addtransport/:id?',
    element: <AddTransportComponent />,
    isProtected: true,
    requiredRole: 'LCA-Admin'
  },
  {
    path: '/disposal',
    element: <ManageDisposalComponent />,
    isProtected: true,
    requiredRole: 'LCA-Admin'
  },
  {
    path: '/disposal/add-disposal/:id?',
    element: <AddDisposalComponent />,
    isProtected: true,
    requiredRole: 'LCA-Admin'
  },
  {
    path: '/pallets',
    element: <ManagepalletsComponent />,
    isProtected: true,
    requiredRole: 'LCA-Admin'
  },
  {
    path: '/pallets/addpallets/:id?',
    element: <AddPalletsComponent />,
    isProtected: true,
    requiredRole: 'LCA-Admin'
  },
  {
    path: '/package-box',
    element: <ManagePackageBoxComponent />,
    isProtected: true,
    requiredRole: 'LCA-Admin'
  },
  {
    path: '/package-box/addpackagebox/:id?',
    element: <AddPackageBoxComponent />,
    isProtected: true,
    requiredRole: 'LCA-Admin'
  },
  {
    path: '/manage-customers',
    element: <ManageCustomerComponent />,
    isProtected: true,
    requiredRole: 'LCA-Admin'
  },
  {
    path: '/manage-customers/addcustomers/:id?',
    element: <AddCustomerComponent />,
    isProtected: true,
    requiredRole: 'LCA-Admin'
  },
  {
    path: '/manage-factory',
    element: <ManageFactoryComponent />,
    isProtected: true,
    requiredRole: 'LCA-Admin'
  },
  {
    path: '/manage-factory/addfactory/:id?',
    element: <AddFactoryComponent />,
    isProtected: true,
    requiredRole: 'LCA-Admin'
  },
  {
    path: '/manage-process',
    element: <ManageProcessComponent />,
    isProtected: true,
    requiredRole: 'LCA-Admin'
  },
  {
    path: '/manage-process/addprocess/:id?',
    element: <AddProcessComponent />,
    isProtected: true,
    requiredRole: 'LCA-Admin'
  },
  {
    path: '/manage-db-version',
    element: <ManageDbVersionComponent />,
    isProtected: true,
    requiredRole: 'LCA-Admin'
  },
  {
    path: '/manage-db-version/add-db-version/:id?',
    element: <AddDbVersionComponent />,
    isProtected: true,
    requiredRole: 'LCA-Admin'
  }
];

// Route renderer component
const RouteRenderer = ({ route }: { route: RouteConfig }) => {
  if (route.isProtected) {
    return (
      <ProtectedRoute 
        requiredRole={route.requiredRole} 
        showUnauthorized={route.showUnauthorized}
        fallbackPath="/dashboard"
      >
        {route.element}
      </ProtectedRoute>
    );
  }
  return route.element;
};

// Updated AppRoutes component
const AppRoutes = () => {
  const { error } = useContext<any>(authContext);
  
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route element={error ? <NotFoundImage error={error}/> : <BasicAppShell />}>
        {routeConfig.map((route, index) => (
          <Route
            key={`${route.path}-${index}`}
            path={route.path}
            element={<RouteRenderer route={route} />}
          />
        ))}
      </Route>
    </Routes>
  );
};

export default memo(AppRoutes);